var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vld-parent"},[_c('Loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":true,"color":'#6BBFAF',"width":128,"height":128,"loader":'spinner'},on:{"update:active":function($event){_vm.isLoading=$event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a7d396","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/General/Loader.vue
// module id = null
// module chunks = 